import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FeatureNetworking() {
  return <section className="w-full border-b border-white/[0.06]" style={{
    backgroundColor: '#09090B'
  }} data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-272">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-273">
          {/* Visual — Left */}
          <div className="relative order-2 lg:order-1" data-id="element-274">
            <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6" data-id="element-275">
              {/* Attendee card grid */}
              <div className="grid grid-cols-2 gap-3" data-id="element-276">
                <div className="bg-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-277">
                  <div className="w-8 h-8 rounded-full bg-blue-500/20 flex-shrink-0" data-id="element-278" />
                  <div className="flex-1 space-y-1.5" data-id="element-279">
                    <div className="bg-white/[0.08] h-2 rounded w-3/4" data-id="element-280" />
                    <div className="bg-white/[0.06] h-1.5 rounded w-1/2" data-id="element-281" />
                  </div>
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-282">
                  <div className="w-8 h-8 rounded-full bg-purple-500/20 flex-shrink-0" data-id="element-283" />
                  <div className="flex-1 space-y-1.5" data-id="element-284">
                    <div className="bg-white/[0.08] h-2 rounded w-3/4" data-id="element-285" />
                    <div className="bg-white/[0.06] h-1.5 rounded w-1/2" data-id="element-286" />
                  </div>
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-287">
                  <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex-shrink-0" data-id="element-288" />
                  <div className="flex-1 space-y-1.5" data-id="element-289">
                    <div className="bg-white/[0.08] h-2 rounded w-3/4" data-id="element-290" />
                    <div className="bg-white/[0.06] h-1.5 rounded w-1/2" data-id="element-291" />
                  </div>
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-292">
                  <div className="w-8 h-8 rounded-full bg-emerald-500/20 flex-shrink-0" data-id="element-293" />
                  <div className="flex-1 space-y-1.5" data-id="element-294">
                    <div className="bg-white/[0.08] h-2 rounded w-3/4" data-id="element-295" />
                    <div className="bg-white/[0.06] h-1.5 rounded w-1/2" data-id="element-296" />
                  </div>
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-297">
                  <div className="w-8 h-8 rounded-full bg-amber-500/20 flex-shrink-0" data-id="element-298" />
                  <div className="flex-1 space-y-1.5" data-id="element-299">
                    <div className="bg-white/[0.08] h-2 rounded w-3/4" data-id="element-300" />
                    <div className="bg-white/[0.06] h-1.5 rounded w-1/2" data-id="element-301" />
                  </div>
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-302">
                  <div className="w-8 h-8 rounded-full bg-pink-500/20 flex-shrink-0" data-id="element-303" />
                  <div className="flex-1 space-y-1.5" data-id="element-304">
                    <div className="bg-white/[0.08] h-2 rounded w-3/4" data-id="element-305" />
                    <div className="bg-white/[0.06] h-1.5 rounded w-1/2" data-id="element-306" />
                  </div>
                </div>
              </div>
            </div>

            {/* Overlapping meeting modal */}
            <div className="absolute -bottom-4 -right-4 lg:right-4 bg-white/[0.07] backdrop-blur-xl border border-white/[0.12] rounded-xl p-4 shadow-[0_0_30px_rgba(0,0,0,0.4)] w-56" data-id="element-307">
              <p className="text-white/60 text-xs font-mono mb-3" data-id="element-308">
                Réserver une réunion
              </p>
              <div className="space-y-2" data-id="element-309">
                <div className="bg-white/[0.06] rounded h-8 border border-white/[0.08]" data-id="element-310" />
                <div className="bg-white/[0.06] rounded h-8 border border-white/[0.08]" data-id="element-311" />
                <div className="bg-white/[0.06] rounded h-8 border border-white/[0.08]" data-id="element-312" />
              </div>
              <div className="mt-3" data-id="element-313">
                <div className="bg-blue-500/30 rounded h-7 w-24 border border-blue-500/20" data-id="element-314" />
              </div>
            </div>
          </div>

          {/* Text — Right */}
          <div className="order-1 lg:order-2" data-id="element-315">
            <p className="text-xs uppercase tracking-wider font-mono text-blue-400" data-id="element-316">
              Networking &amp; Réunions
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 leading-tight font-heading" data-id="element-317">
              Des connexions structurées qui commencent avant même l'arrivée des
              participants.
            </h2>
            <div className="mt-8 space-y-5" data-id="element-318">
              <div className="flex items-start gap-3" data-id="element-319">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-320" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-321">
                  Annuaire participants filtrable par pays, rôle et entreprise
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-322">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-323" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-324">
                  Réservation de réunions 1:1 avec sélecteur date/heure et
                  gestion des fuseaux horaires
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-325">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-326" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-327">
                  Synchronisation Google Calendar et Outlook
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-328">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-329" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-330">
                  Speed Networking : file de matchmaking en direct pour des
                  rencontres spontanées en temps réel
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}